import { useCallback, useContext } from "react"

import useSiteMetadata from "acciondigital-basic-theme/src/hooks/useSiteMetadata"

import {
  siteEvt_PopupAnuncio,
  siteEvt_PopupCerrar,
  siteEvt_Search,
  siteEvt_SelectPromotion,
  siteEvt_ViewItem_Truper,
  siteEvt_BannerClick,
  siteEvt_CotizacionNueva,
  siteEvt_BotonAnuncio,
  siteEvt_ViewItem_Ferre,
  siteEvt_Registro,
  siteEvt_Login,
  siteEvt_Logout,
  siteEvt_ActivarSuscripcion,
  siteEvt_IniciaSesion,
  siteEvt_CrearSuscripcion,
  siteEvt_ActualizarSuscripcion,
  siteEvt_CambiarSuscripcion,
  siteEvt_EliminarSuscripcion,
  siteEvt_CrearPago,
} from "../utils/siteEventsUtils"
import { AuthContext } from "acciondigital-basic-theme/src/context/AuthContext"

export const useSiteEvents = () => {
  const { siteId, API_ACCIONFERRETERA: apiUrl, modoDev } = useSiteMetadata()
  // apiUrl, modoPruebas, user,
  const { user, infoUsuarios } = useContext(AuthContext)

  const sEvt_Registro = useCallback(
    (user, info) => siteEvt_Registro(siteId, user, info),
    [siteId],
  )

  const sEvt_Login = useCallback(
    (us) => siteEvt_Login(siteId, us),
    [siteId],
  )

  const sEvt_Logout = useCallback(
    (props) => siteEvt_Logout(siteId, props),
    [siteId],
  )

  const sEvt_CrearPago = useCallback(
    (pagoInfo, props) => siteEvt_CrearPago(siteId, pagoInfo, props),
    [siteId],
  )

  const sEvt_CrearSuscripcion = useCallback(
    (user, suscripcionInfo, props) => siteEvt_CrearSuscripcion(siteId, user, suscripcionInfo, props),
    [siteId],
  )

  const sEvt_ActualizarSuscripcion = useCallback(
    (user, suscripcionInfo, props) => siteEvt_ActualizarSuscripcion(siteId, user, suscripcionInfo, props),
    [siteId],
  )

  const sEvt_CambiarSuscripcion = useCallback(
    (user, suscripcionInfo, props) => siteEvt_CambiarSuscripcion(siteId, user, suscripcionInfo, props),
    [siteId],
  )

  const sEvt_EliminarSuscripcion = useCallback(
    (user, suscripcionInfo, props) => siteEvt_EliminarSuscripcion(siteId, user, suscripcionInfo, props),
    [siteId],
  )

  const sEvt_ActivarSuscripcion = useCallback(
    (susInfo, props) => siteEvt_ActivarSuscripcion(siteId, user, susInfo, {infoUsuarios, ...props}),
    [siteId, user],
  )

  const sEvt_Search = useCallback(
    (search_term, props) => siteEvt_Search(siteId, user, search_term, props),
    [siteId],
  )

  const sEvt_ViewItem_Truper = useCallback(
    (item, props) => siteEvt_ViewItem_Truper(siteId, user, item, props),
    [siteId],
  )

  const sEvt_ViewItem_Ferre = useCallback(
    (item, props) => siteEvt_ViewItem_Ferre(siteId, user, item, props),
    [siteId],
  )

  const sEvt_SelectPromotion = useCallback(
    (promoInfo, props) => siteEvt_SelectPromotion(siteId, promoInfo, props),
    [siteId],
  )

  const sEvt_PopupAnuncio = useCallback(
    (popupInfo, promoInfo) => {
      siteEvt_PopupAnuncio(siteId, apiUrl, modoDev, user, popupInfo, promoInfo)
    },
    [siteId, apiUrl, modoDev, user],
  )

  const sEvt_PopupCerrar = useCallback(
    (popupInfo, promoInfo) => {
      siteEvt_PopupCerrar(siteId, apiUrl, modoDev, user, popupInfo, promoInfo)
    },
    [siteId, apiUrl, modoDev, user],
  )

  const sEvt_BannerClick = useCallback(
    (bannerInfo, promoInfo) => {
      siteEvt_BannerClick(siteId, apiUrl, modoDev, user, bannerInfo, promoInfo)
    },
    [siteId, apiUrl, modoDev, user],
  )

  const sEvt_CotizacionNueva = useCallback(
    (cotizacionInfo, duplicado = false) => {
      siteEvt_CotizacionNueva(siteId, user, cotizacionInfo, duplicado)
    },
    [siteId, user],
  )

  const sEvt_BotonAnuncio = useCallback(
    anuncioInfo => {
      siteEvt_BotonAnuncio(siteId, user, anuncioInfo)
    },
    [siteId, apiUrl, modoDev, user],
  )

  return {
    sEvt_Registro,
    sEvt_Login,
    sEvt_Logout,
    sEvt_CrearPago,
    sEvt_CrearSuscripcion,
    sEvt_ActualizarSuscripcion,
    sEvt_CambiarSuscripcion,
    sEvt_EliminarSuscripcion,
    sEvt_ActivarSuscripcion,
    sEvt_Search,
    sEvt_ViewItem_Truper,
    sEvt_ViewItem_Ferre,
    sEvt_SelectPromotion,
    sEvt_PopupAnuncio,
    sEvt_PopupCerrar,
    sEvt_BannerClick,
    sEvt_CotizacionNueva,
    sEvt_BotonAnuncio,
  }
}

export const sEvt_IniciaSesion = siteEvt_IniciaSesion
